import styled from '@emotion/styled/macro'
import mq from 'mediaQuery'

export const DetailsItem = styled('div')`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-bottom: 40px;

  ${mq.small`
    align-items: center;
    margin-bottom: 20px;
  `}

  ${p =>
    p.uneditable
      ? mq.small`
    flex-direction: row;
  `
      : mq.small`flex-direction: row;`}
`

export const DetailsKey = styled('div')`
  color: ${({ greyed }) => (greyed ? '#CCD4DA' : '2b2b2b')};
  font-size: 16px;
  letter-spacing: 0px;
  font-weight: 700;
  text-transform: capitalize;
  flex-shrink: 0;
  display: flex;
  line-height: 1.2;
  margin-bottom: 10px;

  ${mq.small`
    align-items: center;
    margin-bottom: 0;
    font-size: 24px;
    max-width: 220px;
    min-width: 180px;
  `}
`

export const DetailsValue = styled('div')`
  font-size: 14px;
  font-weight: 700;
  font-family: Overpass Mono;
  white-space: nowrap;
  overflow: hidden;
  display: inline-flex;
  text-overflow: ellipsis;
  line-height: 1.3;
  ${mq.small`
    font-size: 20px;
    align-items: center;
    margin-top: 0;
  `}
  ${p =>
    p.editing &&
    p.editable &&
    mq.small`
    padding-right: 5px;
  `}

  a {
    display: flex;
    overflow: hidden;
  }
`
/* Container element for key/value */
export const DetailsContent = styled('div')`
  display: flex;
  justify-content: flex-start;
  position: relative;
  flex-direction: column;
  width: 100%;
  ${({ editing }) => editing && 'margin-bottom: 30px'};
  transition: 0.3s;
  ${mq.medium`
    flex-direction: row;
    align-items: center;
  `}
`
